import { Pipe, PipeTransform } from '@angular/core';


@Pipe({
  name: 'vuidlen'
})
export class ValidationUidLen implements PipeTransform {

  constructor() { }

  transform(value: string): string {
    // Min 7 and Max 18 characters
    if (value && value.length >= 7 && value.length <= 18) {
      return 'valid';
    }
    // Min 7 and Max 18 characters
   return 'invalid';
  }
}
